# Generated by https://pagedraw.io/pages/1470
React = require 'react'
createReactClass = require 'create-react-class'
Banner = require './banner'
Projectitem = require './projectitem'
Textbutton = require './textbutton'
Pageitem = require './pageitem'
{SketchDropzone} = require './../pagedraw-requires'
{FigmaModal} = require './../pagedraw-requires'
Footer = require './footer'


module.exports = Main = createReactClass {
    displayName: 'Main'
    render: ->
        React.createElement("div", {"className": "main"},
          React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
              @import url('https://fonts.googleapis.com/css?family=Lato:');
              
              .main {
                  display: flex;
                  flex-grow: 1;
              }
              
              .main-figma-3 {
                  display: flex;
                  flex-direction: column;
                  background: #FFFFFF;
                  min-height: 100vh;
                  flex-grow: 1;
              }
              
              .main-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-instance_of_deleted_component-4 {
                  flex-grow: 1;
                  flex-basis: 0px;
                  display: flex;
                  flex-direction: column;
              }
              
              .main-0-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  justify-content: center;
              }
              
              .main-body-1 {
                  display: flex;
                  flex-direction: column;
              }
              
              .main-0-0-1-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-sidebar-2 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 45px;
                  padding-bottom: 20px;
              }
              
              .main-0-0-1-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-projects-3 {
                  display: flex;
                  flex-direction: column;
              }
              
              .main-0-0-1-0-0-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-text_1 {
                  width: 294px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: #000000;
                  font-size: 16px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-0-0-1-0-0-0-0-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 7px;
              }
              
              .main-rectangle_6 {
                  width: 294px;
                  height: 1px;
                  flex-shrink: 0;
                  background: rgb(162, 162, 162);
              }
              
              .main-0-0-1-0-0-0-0-0-2 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 8px;
              }
              
              .main-0-0-1-0-0-0-0-0-2-0 {
                  display: flex;
                  flex-direction: column;
              }
              
              .main-project_list-2 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 1px;
                  background: rgb(255, 255, 255);
                  flex-grow: 1;
              }
              
              .main-0-0-1-0-0-0-0-0-2-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-projectitem_instance-9 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 294px;
              }
              
              .main-0-0-1-0-0-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 10px;
                  padding-left: 1px;
              }
              
              .main-0-0-1-0-0-0-1-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .main-new_project_button-3 {
                  display: flex;
                  flex-direction: column;
                  min-width: 293px;
                  flex-grow: 1;
              }
              
              .main-0-0-1-0-0-0-2 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 28px;
              }
              
              .main-collaborators-4 {
                  display: flex;
                  flex-direction: column;
              }
              
              .main-0-0-1-0-0-0-2-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-text_2 {
                  width: 294px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: #000000;
                  font-size: 16px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-0-0-1-0-0-0-2-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 7px;
              }
              
              .main-rectangle_9 {
                  width: 294px;
                  height: 1px;
                  flex-shrink: 0;
                  background: rgb(162, 162, 162);
              }
              
              .main-0-0-1-0-0-0-2-0-2 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 8px;
              }
              
              .main-0-0-1-0-0-0-2-0-2-0 {
                  display: flex;
                  flex-direction: column;
                  margin-top: -12px;
              }
              
              .main-collab_list-9 {
                  display: flex;
                  flex-direction: column;
                  padding-bottom: 1px;
                  background: rgb(255, 255, 255);
                  margin-top: 12px;
                  flex-grow: 1;
              }
              
              .main-0-0-1-0-0-0-2-0-2-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-right: 5px;
              }
              
              .main-0-0-1-0-0-0-2-0-2-0-0-0-0-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .main-text_15 {
                  width: 273px;
                  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                  color: rgb(22, 98, 140);
                  font-size: 14px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: underline;
                  text-align: left;
                  word-wrap: break-word;
                  flex-grow: 1;
              }
              
              .main-text_16 {
                  flex-shrink: 0;
                  margin-left: 5px;
                  cursor: pointer;
                  font-family: "Lato", sans-serif;
                  color: rgb(142, 142, 142);
                  font-size: 11px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
              }
              
              .main-0-0-1-0-0-0-2-0-3 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 17px;
              }
              
              .main-text_input_2 {
                  width: 242px;
                  height: 29px;
                  flex-shrink: 0;
                  border-radius: 2px;
                  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                  color: #000;
                  font-size: 14px;
                  font-weight: normal;
                  font-style: normal;
                  text-align: left;
                  letter-spacing: 0px;
                  line-height: normal;
                  word-wrap: normal;
                  padding: 6px 12px;
                  border: 1px solid #cccccc;
              }
              
              .main-button_2 {
                  width: 42px;
                  height: 29px;
                  flex-shrink: 0;
                  margin-left: 10px;
                  border-radius: 6px;
                  background: rgb(99, 60, 252);
                  border-width: 0px;
                  font-family: "Lato", sans-serif;
                  color: #fff;
                  font-size: 11px;
                  line-height: normal;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
                  letter-spacing: normal;
                  border: none;
              }
              
              .main-0-0-1-0-0-0-3 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 25px;
                  padding-left: 1px;
              }
              
              .main-pagedraw_json-9 {
                  display: flex;
                  flex-direction: column;
              }
              
              .main-0-0-1-0-0-0-3-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-right: 195px;
              }
              
              .main-0-0-1-0-0-0-3-0-0-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .main-text_3 {
                  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                  color: #000000;
                  font-size: 14px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
                  flex-grow: 1;
              }
              
              .main-0-0-1-0-0-0-3-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 13px;
              }
              
              .main-rectangle_5 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 12px;
                  padding-bottom: 11px;
                  border-radius: 4px;
                  background: rgb(244, 244, 244);
              }
              
              .main-0-0-1-0-0-0-3-0-1-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 14px;
                  padding-right: 16px;
              }
              
              .main-text_6 {
                  width: 263px;
                  flex-shrink: 0;
                  font-family: monaco, Consolas, 'Lucida Console', monospace;
                  color: rgb(89, 9, 165);
                  font-size: 12px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-0-0-1-0-0-0-4 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 8px;
              }
              
              .main-0-0-1-0-0-0-4-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .main-text_15-4 {
                  width: 294px;
                  font-family: "Lato", sans-serif;
                  color: rgb(22, 98, 140);
                  font-size: 10px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: underline;
                  text-align: left;
                  word-wrap: break-word;
                  flex-grow: 1;
              }
              
              .main-0-0-1-0-0-1 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 75px;
                  padding-top: 45px;
                  padding-bottom: 107px;
              }
              
              .main-0-0-1-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-rectangle_1 {
                  display: flex;
                  flex-direction: column;
              }
              
              .main-0-0-1-0-0-1-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-text_17 {
                  width: 751px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgb(45, 45, 47);
                  font-size: 40px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-0-0-1-0-0-1-0-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 15px;
              }
              
              .main-rectangle_7 {
                  width: 751px;
                  height: 1px;
                  flex-shrink: 0;
                  background: rgb(154, 154, 154);
              }
              
              .main-0-0-1-0-0-1-0-0-2 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 9px;
              }
              
              .main-0-0-1-0-0-1-0-0-2-0 {
                  display: flex;
                  flex-direction: column;
                  margin-top: -7px;
              }
              
              .main-doc_list-4 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 10px;
                  padding-bottom: 9px;
                  background: rgba(255, 255, 255, 0);
                  margin-top: 7px;
                  flex-grow: 1;
              }
              
              .main-0-0-1-0-0-1-0-0-2-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-pageitem_instance-8 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 751px;
              }
              
              .main-0-0-1-0-0-1-0-0-3 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 26px;
                  padding-left: 1px;
              }
              
              .main-text_input-3 {
                  width: 659px;
                  height: 36px;
                  flex-shrink: 0;
                  border-radius: 2px;
                  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                  color: #000;
                  font-size: 14px;
                  font-weight: normal;
                  font-style: normal;
                  text-align: left;
                  letter-spacing: 0px;
                  line-height: normal;
                  word-wrap: normal;
                  padding: 6px 12px;
                  border: 1px solid #cccccc;
              }
              
              .main-button_3 {
                  width: 81px;
                  height: 36px;
                  flex-shrink: 0;
                  margin-left: 10px;
                  border-radius: 6px;
                  background: rgb(99, 60, 252);
                  border-width: 0px;
                  font-family: "Lato", sans-serif;
                  color: #fff;
                  font-size: 11px;
                  line-height: normal;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
                  letter-spacing: normal;
                  border: none;
              }
              
              .main-0-0-1-0-0-1-0-0-4 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 13px;
                  padding-right: 1px;
              }
              
              .main-new_doc_button-9 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 6px;
                  padding-bottom: 11px;
                  border-radius: 7px;
                  cursor: pointer;
                  background: rgb(245, 245, 245);
                  border: 3px solid rgb(214, 214, 214);
              }
              
              .main-0-0-1-0-0-1-0-0-4-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 13px;
                  padding-right: 14px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-0-0-0 {
                  display: flex;
                  flex-direction: column;
                  padding-bottom: 6px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-text_7 {
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgba(26, 23, 116, 0.6);
                  font-size: 90px;
                  line-height: 60px;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
                  padding-right: 0.796875px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-0-0-1 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 14px;
                  padding-top: 6px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-text_19 {
                  width: 144px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgb(26, 23, 116);
                  font-size: 18px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-0-0-1-0-0-1-0-0-4-0-0-1-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 4px;
              }
              
              .main-text_13 {
                  width: 144px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgba(0, 0, 0, 0.7);
                  font-size: 14px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-import_sketch_button-2 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 9px;
                  padding-top: 11px;
                  padding-bottom: 11px;
                  border-radius: 7px;
                  cursor: pointer;
                  background: rgb(245, 245, 245);
                  border: 3px solid rgb(214, 214, 214);
              }
              
              .main-0-0-1-0-0-1-0-0-4-1-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 9px;
                  padding-right: 14px;
              }
              
              .main-image_3 {
                  width: 61px;
                  height: 61px;
                  flex-shrink: 0;
                  background-image: url('https://complex-houses.surge.sh/5a26092e-6389-43d1-8086-3c44f8c44484/sketch-symbol-transparent@2x.png');
                  background-size: cover;
                  background-position: center;
              }
              
              .main-0-0-1-0-0-1-0-0-4-1-0-0-1 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 10px;
                  padding-top: 1px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-1-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-text_5 {
                  width: 144px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgb(26, 23, 116);
                  font-size: 18px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-0-0-1-0-0-1-0-0-4-1-0-0-1-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 4px;
              }
              
              .main-text_4 {
                  width: 144px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgba(0, 0, 0, 0.7);
                  font-size: 14px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-import_sketch_button-5 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 9px;
                  padding-top: 12px;
                  padding-bottom: 11px;
                  border-radius: 7px;
                  cursor: pointer;
                  background: rgb(245, 245, 245);
                  border: 3px solid rgb(214, 214, 214);
              }
              
              .main-0-0-1-0-0-1-0-0-4-2-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 16px;
                  padding-right: 14px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-2-0-0-0 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 1px;
                  padding-bottom: 2px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-2-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-image_3-8 {
                  width: 38px;
                  height: 57px;
                  flex-shrink: 0;
                  border-width: 0px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-2-0-0-1 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 16px;
              }
              
              .main-0-0-1-0-0-1-0-0-4-2-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .main-text_5-9 {
                  width: 154px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgb(26, 23, 116);
                  font-size: 18px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-0-0-1-0-0-1-0-0-4-2-0-0-1-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 4px;
              }
              
              .main-text_4-3 {
                  width: 154px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgba(0, 0, 0, 0.7);
                  font-size: 14px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .main-0-0-2 {
                  width: 0px;
                  flex-shrink: 0;
                  flex-grow: 1;
                  flex-basis: 0px;
              }
              
              .main-0-0-3 {
                  display: flex;
                  flex-shrink: 0;
                  justify-content: center;
              }
              
              .main-unnamed_instance_2 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
              }
              
              * {
                  box-sizing: border-box;
              }
              
              body {
                  margin: 0;
              }
              
              button:hover {
                  cursor: pointer;
              }
              
              a {
                  text-decoration: none;
                  color: inherit;
              }
              
              .pd-onhover-parent >.pd-onhover {
                  display: none;
              }
              
              .pd-onhover-parent:hover > * {
                  display: none;
              }
              
              .pd-onhover-parent:hover > .pd-onhover {
                  display: flex;
              }
              
              .pd-onactive-parent > .pd-onactive {
                  display: none;
              }
              
              .pd-onactive-parent:active > * {
                  display: none;
              }
              
              .pd-onactive-parent:active > .pd-onactive {
                  display: flex;
              }
              
              .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                  display: none;
              }
          """)}),  
          ( if ((if this.props.figma_importing then "figma" else "no_figma") == "figma")
              React.createElement("div", {"className": "main-figma-3"},
                  React.createElement("div", {"className": "main-0-0-0"},
                      React.createElement("div", {"className": "main-instance_of_deleted_component-4"},
                          React.createElement(Banner, {"username": (this.props.current_user.name), "logout": ((@props.logout))}) 
                      )
                  ),
                  React.createElement("div", {"className": "main-0-0-1"},
                      React.createElement("div", {"className": "main-body-1"},
                          React.createElement("div", {"className": "main-0-0-1-0-0"},
                              React.createElement("div", {"className": "main-sidebar-2"},
                                  React.createElement("div", {"className": "main-0-0-1-0-0-0-0"},
                                      React.createElement("div", {"className": "main-projects-3"},
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-0-0-0"},
                                              React.createElement("div", {"className": "main-text_1"}, "Other Projects")
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-0-0-1"},
                                              React.createElement("div", {"className": "main-rectangle_6"}) 
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-0-0-2"},
                                              React.createElement("div", {"className": "main-0-0-1-0-0-0-0-0-2-0"},
                                                  ( this.props.apps.map (app, i) =>
                                                      React.createElement("div", {"key": (i), "className": "main-project_list-2"},
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-0-0-2-0-0-0-0"},
                                                              React.createElement("div", {"className": "main-projectitem_instance-9"},
                                                                  React.createElement(Projectitem, {"name": (app.name), "selected": ((app.id == this.props.app.id)), "onClick": ((=> @props.handleAppChanged(app.id)))}) 
                                                              )
                                                          )
                                                      )
                                                  )
                                              )
                                          )
                                      )
                                  ),
                                  React.createElement("div", {"className": "main-0-0-1-0-0-0-1"},
                                      React.createElement("a", {"href": "/apps/new", "className": "main-0-0-1-0-0-0-1-0"},
                                          React.createElement("div", {"className": "main-new_project_button-3"},
                                              React.createElement(Textbutton, {"text": ("+ NEW PROJECT"), "onClick": ((->)), "disabled": (false)}) 
                                          )
                                      )
                                  ),
                                  React.createElement("div", {"className": "main-0-0-1-0-0-0-2"},
                                      React.createElement("div", {"className": "main-collaborators-4"},
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-2-0-0"},
                                              React.createElement("div", {"className": "main-text_2"}, "Collaborators")
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-2-0-1"},
                                              React.createElement("div", {"className": "main-rectangle_9"}) 
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-2-0-2"},
                                              React.createElement("div", {"className": "main-0-0-1-0-0-0-2-0-2-0"},
                                                  ( this.props.app.users.map (user, i) =>
                                                      React.createElement("div", {"key": (i), "className": "main-collab_list-9"},
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-2-0-2-0-0-0-0"},
                                                              React.createElement("a", {"href": "mailto:#{user.email}", "className": "main-0-0-1-0-0-0-2-0-2-0-0-0-0-0"},
                                                                  React.createElement("div", {"className": "main-text_15"}, ( user.email ))
                                                              ),
                                                              React.createElement("div", {"onClick": (=> @props.handleCollaboratorDelete(user.id)), "className": "main-text_16"},
                                                                  ("╳")
                                                              )
                                                          )
                                                      )
                                                  )
                                              )
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-2-0-3"},
                                              React.createElement("input", {"type": "text", "placeholder": "add new collaborator", "value": (@props.collaboratorField), "onChange": ((e) => @props.setState collaboratorField: e.target.value), "className": "main-text_input_2"}),  
                                              React.createElement("button", {"type": "submit", "onClick": (@props.handleCollaboratorSubmit), "className": "main-button_2"},
                                                  React.createElement("span", null, "Add")
                                              )
                                          )
                                      )
                                  ),
                                  React.createElement("div", {"className": "main-0-0-1-0-0-0-3"},
                                      React.createElement("div", {"className": "main-pagedraw_json-9"},
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-3-0-0"},
                                              React.createElement("a", {"href": "https://documentation.pagedraw.io/install", "className": "main-0-0-1-0-0-0-3-0-0-0"},
                                                  React.createElement("div", {"className": "main-text_3"}, "pagedraw.json")
                                              )
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-0-3-0-1"},
                                              React.createElement("div", {"className": "main-rectangle_5"},
                                                  React.createElement("div", {"className": "main-0-0-1-0-0-0-3-0-1-0-0"},
                                                      React.createElement("div", {"className": "main-text_6"},
                                                          ( this.props.pagedrawJsonBody )
                                                      )
                                                  )
                                              )
                                          )
                                      )
                                  ),
                                  React.createElement("div", {"className": "main-0-0-1-0-0-0-4"},
                                      React.createElement("a", {"href": "https://documentation.pagedraw.io/install/", "className": "main-0-0-1-0-0-0-4-0"},
                                          React.createElement("div", {"className": "main-text_15-4"}, """
                                              INSTALLATION \x2F GETTING STARTED GUIDE
""")
                                      )
                                  )
                              ),
                              React.createElement("div", {"className": "main-0-0-1-0-0-1"},
                                  React.createElement("div", {"className": "main-0-0-1-0-0-1-0"},
                                      React.createElement("div", {"className": "main-rectangle_1"},
                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-0"},
                                              React.createElement("div", {"className": "main-text_17"}, ( this.props.app.name ))
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-1"},
                                              React.createElement("div", {"className": "main-rectangle_7"}) 
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-2"},
                                              React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-2-0"},
                                                  ( this.props.app.pages.map (page, i) =>
                                                      React.createElement("div", {"key": (i), "className": "main-doc_list-4"},
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-2-0-0-0-0"},
                                                              React.createElement("div", {"className": "main-pageitem_instance-8"},
                                                                  React.createElement(Pageitem, {"state": ("A"), "text": (page.url), "link": (("/pages/#{page.id}")), "handleDelete": ((=> @props.handlePageDelete(page)))}) 
                                                              )
                                                          )
                                                      )
                                                  )
                                              )
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-3"},
                                              React.createElement("input", {"type": "text", "placeholder": "new doc name", "value": (@props.pageField), "onChange": ((e) => @props.setState pageField: e.target.value), "className": "main-text_input-3"}),  
                                              React.createElement("button", {"type": "submit", "onClick": (this.props.handlePageSubmit), "className": "main-button_3"},
                                                  React.createElement("span", null, "ADD")
                                              )
                                          ),
                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4"},
                                              React.createElement("div", {"onClick": (this.props.handleNewDoc), "className": "main-new_doc_button-9"},
                                                  React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-0-0"},
                                                      React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-0-0-0"},
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-0-0-0-0"},
                                                              React.createElement("div", {"className": "main-text_7"}, "+")
                                                          )
                                                      ),
                                                      React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-0-0-1"},
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-0-0-1-0"},
                                                              React.createElement("div", {"className": "main-text_19"}, "New Doc")
                                                          ),
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-0-0-1-1"},
                                                              React.createElement("div", {"className": "main-text_13"}, """
                                                                  Start from a blank design
""")
                                                          )
                                                      )
                                                  )
                                              ),
                                              React.createElement(SketchDropzone, {"app": ((@props.app))},
                                                  React.createElement("div", {"className": "main-import_sketch_button-2"},
                                                      React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-1-0-0"},
                                                          React.createElement("div", {"className": "main-image_3"}),  
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-1-0-0-1"},
                                                              React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-1-0-0-1-0"},
                                                                  React.createElement("div", {"className": "main-text_5"}, "Import Sketch")
                                                              ),
                                                              React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-1-0-0-1-1"},
                                                                  React.createElement("div", {"className": "main-text_4"}, """
                                                                      Click or drop a Sketch file here to upload
""")
                                                              )
                                                          )
                                                      )
                                                  )
                                              ),
                                              React.createElement(FigmaModal, {"app": ((@props.app)), "show_figma_modal": ((@props.figma_modal)), "figma_access_token": ((@props.figma_access_token))},
                                                  React.createElement("div", {"className": "main-import_sketch_button-5"},
                                                      React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-2-0-0"},
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-2-0-0-0"},
                                                              React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-2-0-0-0-0"},
                                                                  React.createElement("img", {"src": "https://complex-houses.surge.sh/8fb8956e-20d0-4114-b516-a2d8c5e4dd7e/original", "className": "main-image_3-8"}) 
                                                              )
                                                          ),
                                                          React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-2-0-0-1"},
                                                              React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-2-0-0-1-0"},
                                                                  React.createElement("div", {"className": "main-text_5-9"}, "Import Figma")
                                                              ),
                                                              React.createElement("div", {"className": "main-0-0-1-0-0-1-0-0-4-2-0-0-1-1"},
                                                                  React.createElement("div", {"className": "main-text_4-3"}, """
                                                                      Start from a design in Figma 
""")
                                                              )
                                                          )
                                                      )
                                                  )
                                              )
                                          )
                                      )
                                  )
                              )
                          )
                      )
                  ),
                  React.createElement("div", {"className": "main-0-0-2"}),  
                  React.createElement("div", {"className": "main-0-0-3"},
                      React.createElement("div", {"className": "main-unnamed_instance_2"}, React.createElement(Footer, null), " ")
                  )
              )
          )
      )
}



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/meta-app-index-view.cjsx